import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import { Container } from '../Card/styles';
import Stack from '@mui/material/Stack';
export const EditCard = styled(Container)<{ $isSm: boolean }>`
  padding: 0;
  width: ${({ $isSm }) => ($isSm ? '90%' : '700px')};
  height: ${({ $isSm }) => ($isSm ? 'auto' : '400px')};
`;

export const EditStack = styled(Stack)<{ $isSm: boolean }>`
  flex-direction: ${({ $isSm }) => ($isSm ? 'column' : 'row')};
  width: 100%;
  height: 100%;
`;

export const InfoStack = styled(Stack)`
  flex-direction: column;
  padding: 24px;
  gap: 32px;
  flex: 0 0 60%;
`;

export const UserIdChip = styled(Chip)`
  font-weight: 400;
  padding: 0 12px;
  border: none;
`;

export const UserRoleChip = styled(Chip)`
  font-weight: 400;
  padding: 0 12px;
  background-color: ${({ theme }) => theme.palette.grey['04']};
`;

export const NameField = styled(TextField)<{ input: string }>`
  & .MuiInputBase-root {
    ${({ input }) => `
      width: ${input.length * 2.2 + 1 || 1}ch;
    `}
    height: 48px;
  }
  & .MuiInputBase-input {
    font-size: 28px;
    font-weight: 700;
    font-family: Poppins;
  }
  width: 100%;
`;

export const EmailField = styled(TextField)<{ input: string }>`
  & .MuiInputBase-root {
    ${({ input }) => `
      width: ${input.length * 0.75 + 1 || 1}ch;
    `}
    margin-top: 4px;
    height: 32px;
  }
  & .MuiInputBase-input {
    font-size: 12px;
    font-weight: 400;
    font-family: Poppins;
  }
  width: 100%;
`;
